/* Cincy upload preview.
   One action: tapping the "Upload your own" method card opens the file
   picker, and choosing a file drops the patch straight onto the main product
   photo via the shared CincyPreview controller (which reuses the design
   Worker's render engine). SVG uploads pass through; raster uploads (PNG/JPG)
   are wrapped in <image> so the same single-color engrave filter applies. The
   chosen arrangement/placement are stored as line-item properties. */
(function () {
  function boot() {
    var panel = document.querySelector('.cincy-panel[data-method="Upload your own"]');
    if (!panel) return;
    var wrap = panel.querySelector('.cincy-uprev');
    if (!wrap || wrap.__cincyInit) return;
    if (!window.CincyPreview) return; // controller not loaded yet; retry on ready
    wrap.__cincyInit = true;

    var stage = wrap.querySelector('.cincy-uprev__stage');
    var note = wrap.querySelector('.cincy-uprev__note');
    var fileInput = panel.querySelector('.cincy-upload__input');
    var customizer = panel.closest('cincy-customizer') || document;
    var radio = customizer.querySelector('input[name="properties[Design Method]"][value="Upload your own"]');
    var cardDesc = customizer.querySelector('[data-upload-desc]');
    var sizeProp = panel.querySelector('.cincy-uprev__size-prop');
    var placeProp = panel.querySelector('.cincy-uprev__place-prop');
    var linkProp = panel.querySelector('.cincy-upload__link');
    var addTextBtn = panel.querySelector('.cincy-upload__addtext');
    var lastRaw = null;
    var waiting = false;     // file chosen before the render engine loaded

    function sel(name) {
      var el = customizer.querySelector('select[name="properties[' + name + ']"]');
      return el ? el.value : '';
    }
    function hatColor() {
      var el = document.querySelector(
        'variant-selects input[name="Color"]:checked,' +
        'variant-selects select[name="Color"],' +
        'fieldset [name="Color"]:checked'
      );
      return el && el.value ? el.value : '';
    }

    function selections() {
      return {
        shape: sel('Patch Shape'),
        leather: sel('Leatherette'),
        border: sel('Border'),
        hatColor: hatColor(),
        hatSrc: window.CincyPreview.hatImage(customizer)
      };
    }

    var ctl = window.CincyPreview.create({
      stage: stage,
      getRaw: function () { return lastRaw; },
      getSelections: selections,
      onChange: function (state) {
        var d = window.CincyPreview.describe(state);
        if (sizeProp) sizeProp.value = d.design;
        if (placeProp) placeProp.value = d.placement;
      }
    });

    function pickFile() {
      if (!fileInput) return;
      // Open synchronously inside the tap (iOS Safari blocks deferred opens).
      // The customizer enables this panel on the radio's change event, which
      // fires after click, so enable the input here first.
      fileInput.disabled = false;
      fileInput.click();
    }

    // The Upload tile shows the chosen file (tap the tile again to swap it).
    function showFile(name) {
      if (!cardDesc) return;
      cardDesc.textContent = name || '';
      cardDesc.title = name || '';
      // The title's ⓘ tip now also says how to swap the file.
      var label = radio && radio.closest('.cincy-method');
      if (label && name) {
        label.dataset.desc = 'PNG, JPG or SVG — we clean it up and vectorize it free. ' +
          'Arrange it on the hat photo, and tap Upload again to swap the file.';
        if (customizer.refreshInfo) customizer.refreshInfo();
      }
    }

    function render() {
      if (!lastRaw) return;
      if (!window.CincyEmbed || !window.CincyEmbed.ready) { waiting = true; return; }
      waiting = false;
      ctl.render();
      if (note) note.hidden = false;
      if (addTextBtn) addTextBtn.hidden = !window.CincyText || !window.CincyText.addImage;
    }

    // "+ Add text": carry the image (where the customer arranged it) into the
    // text editor, where image + text pieces each drag on their own.
    // The current upload as a piece for the text editor (or null).
    function current() {
      if (!lastRaw) return null;
      var f = fileInput && fileInput.files && fileInput.files[0];
      var link = linkProp && linkProp.value;
      var st = ctl.getState(), place = null;
      var art = window.CincyPreview.parseArt && window.CincyPreview.parseArt(lastRaw);
      if (st && st.art && art && st.touched && st.touched.art) {
        // Upload art box (meet-fit, scaled by z) in fractions of the patch box.
        var E = window.CincyEmbed, bb = E.buildContext(selections()).shape.bbox;
        place = { cx: 0.5 + st.art.ox, cy: 0.5 + st.art.oy, w: Math.min(1, (bb.h / bb.w) / art.ar) * st.art.z };
      }
      return {
        raw: lastRaw, file: f || null, link: f ? '' : link, fromUpload: true, place: place,
        name: f ? f.name : (link ? link.split(/[?#]/)[0].split('/').pop() : '')
      };
    }
    function addText() {
      if (!lastRaw || !window.CincyText || !window.CincyText.addImage) return;
      window.CincyText.addImage(current());
    }
    if (addTextBtn) addTextBtn.addEventListener('click', addText);

    function loadFile(f, cb) {
      var isSvg = /svg/i.test(f.type) || /\.svg$/i.test(f.name);
      var r = new FileReader();
      r.onerror = function () { alert('Could not read that file.'); };
      if (isSvg) {
        r.onload = function () { lastRaw = r.result; cb(); };
        r.readAsText(f);
        return;
      }
      r.onload = function () {
        var img = new Image();
        img.onload = function () {
          var E = window.CincyEmbed;
          var w = img.naturalWidth || img.width || 100, h = img.naturalHeight || img.height || 100;
          // wrapRaster lives in the engine; build the same wrapper if it isn't loaded yet.
          lastRaw = (E && E.wrapRaster) ? E.wrapRaster(r.result, w, h) :
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '"><image href="' + r.result +
            '" x="0" y="0" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid meet"/></svg>';
          cb();
        };
        img.onerror = function () { alert('Could not read that image.'); };
        img.src = r.result;
      };
      r.readAsDataURL(f);
    }

    // The method card IS the upload button. `click` fires on the radio for
    // both a first selection and a re-tap of the already-selected card.
    if (radio) {
      radio.addEventListener('click', pickFile);
    }

    // Pre-filled link (?image=<url>): the team downloads it from the
    // "Design Link" property. The preview points an <image> at the URL, which
    // renders cross-origin without CORS; if it won't load, the link still
    // travels with the order.
    function useLink(url) {
      if (!/^https?:\/\/[^\s"'<>]+$/i.test(url)) return;
      if (linkProp) linkProp.value = url;
      var name = url.split(/[?#]/)[0].split('/').pop() || url;
      showFile(decodeURIComponent(name) + ' (from link)');
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth || 1000, h = img.naturalHeight || 1000;
        var href = url.replace(/&/g, '&amp;');
        lastRaw = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '"><image href="' + href +
          '" x="0" y="0" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid meet"/></svg>';
        render();
      };
      img.src = url;
    }
    // Shared with cincy-webmcp.js (browser AI agents set the art the same way).
    window.CincyUpload = {
      useLink: useLink,
      current: current,
      hasArt: function () { return !!lastRaw || !!(linkProp && linkProp.value) || !!(fileInput && fileInput.files && fileInput.files.length); }
    };

    var linkParam = new URLSearchParams(window.location.search).get('image');
    if (linkParam) useLink(linkParam.trim());

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var f = fileInput.files && fileInput.files[0];
        if (!f) return;
        if (linkProp) linkProp.value = ''; // an attached file replaces the link
        showFile(f.name);
        loadFile(f, function () {
          // Text already on the patch: the image joins it instead of replacing it.
          var T = window.CincyText;
          if (T && T.hasLines && T.hasLines() && T.addImage(Object.assign(current(), { openText: false }))) return;
          render();
          ctl.reveal();
        });
      });
    }

    customizer.querySelectorAll('select[data-patch-prop]').forEach(function (s) {
      s.addEventListener('change', function () { if (lastRaw) render(); });
    });
    // Re-render with the newly selected hat when the variant changes.
    var form = panel.closest('form');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target === fileInput) return;
        if (lastRaw) setTimeout(render, 120);
      });
    }
    window.addEventListener('cincy-embed-ready', function () { if (waiting) render(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('cincy-embed-ready', boot);
})();
